export enum WidgetText {
  LIST_TITLE = 'LIST_TITLE',
  TITLE = 'TITLE',
  DATE = 'DATE',
  LOCATION = 'LOCATION',
  DESCRIPTION = 'DESCRIPTION',
  LINK = 'LINK',
}

export enum ADDITIONAL_MOBILE_LIST_LAYOUT {
  GRID = 'GRID',
}
